module.exports = __webpack_public_path__ + "static/Maine - textiles and mixed media 3x4ft - 2023-640083d3e3510874c9d1393d84f13626.jpg";